import { SG, JP, HK } from '@snapask/common-components/dist/constants/locales';

export const LIVE_GROUPS = 'live_groups';
export const BUNDLE_BANNERS = 'bundle_banners';
export const TOKENS = 'tokens';
export const TOKEN_PACKS = 'token_packs';
export const WEB_SUBSCRIPTION_GROUPS = 'web_subscription_groups';
export const MINI_CLASSES = 'mini_classes';

export const PLAN_SECTION_LIST = [
  BUNDLE_BANNERS,
  TOKENS,
  TOKEN_PACKS,
  LIVE_GROUPS,
  WEB_SUBSCRIPTION_GROUPS,
  MINI_CLASSES,
];

export const PRODUCT_FEATURES = 'features';
export const PRODUCT_COMPARE = 'compare';
export const TESTIMONIALS = 'testimonials';
export const FAQ_BLOCK = 'faq';
export const SECURE_PAYMENT = 'securepayment';
export const PROMOTION = 'promotion';

export const DEFAULT_ACTIVE_GROUP_IS_YEARLY = [SG, JP, HK];



// WEBPACK FOOTER //
// ./app/constants/premiumPage.js